import { render, staticRenderFns } from "./EditBatch.vue?vue&type=template&id=274555ca&scoped=true&"
import script from "./EditBatch.vue?vue&type=script&lang=js&"
export * from "./EditBatch.vue?vue&type=script&lang=js&"
import style0 from "./EditBatch.vue?vue&type=style&index=0&id=274555ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274555ca",
  null
  
)

export default component.exports